if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        this.updateOptionAvailability();
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });

      this.sortNumericOptions();
      this.updateOptionAvailability();
    }

    sortNumericOptions() {
      this.querySelectorAll('[data-option-name]').forEach((field) => {
        if (field.dataset.optionName.trim().toLowerCase() !== 'quantity') return;

        const select = field.querySelector('select');
        if (select) {
          const options = Array.from(select.options);
          if (options.every((option) => Number.isFinite(this.getNumericOptionValue(option.value)))) {
            options
              .sort((first, second) => this.getNumericOptionValue(first.value) - this.getNumericOptionValue(second.value))
              .forEach((option) => select.appendChild(option));
          }
          return;
        }

        const content = field.querySelector('.m-product-option--content');
        if (!content) return;

        const nodes = Array.from(content.children);
        if (nodes.every((node) => Number.isFinite(this.getNumericOptionValue(node.dataset.value)))) {
          nodes
            .sort((first, second) => this.getNumericOptionValue(first.dataset.value) - this.getNumericOptionValue(second.dataset.value))
            .forEach((node) => content.appendChild(node));
        }
      });
    }

    getNumericOptionValue(value) {
      return Number(String(value).replace(/[^0-9.-]/g, ''));
    }

    get variantAvailabilityData() {
      const data = this.querySelector('[data-variant-availability]');
      if (!data) return [];

      try {
        return JSON.parse(data.textContent);
      } catch (error) {
        console.error('Unable to parse variant availability data', error);
        return [];
      }
    }

    updateOptionAvailability() {
      const variants = this.variantAvailabilityData;
      const optionGroups = Array.from(this.querySelectorAll('.m-product-option'));

      if (!variants.length || !optionGroups.length) return;

      const selectedValues = optionGroups.map((group) => {
        const select = group.querySelector('select');
        if (select) return select.value;

        return group.querySelector('input[type="radio"]:checked')?.value;
      });

      optionGroups.forEach((group, optionIndex) => {
        const choices = group.querySelectorAll('option[data-option-value-id], input[type="radio"][data-option-value-id]');

        choices.forEach((choice) => {
          const isAvailable = variants.some((variant) => {
            if (!variant.available) return false;

            return variant.options.every((variantValue, variantOptionIndex) => {
              const requiredValue = variantOptionIndex === optionIndex
                ? choice.value
                : selectedValues[variantOptionIndex];

              return !requiredValue || variantValue === requiredValue;
            });
          });

          choice.disabled = !isAvailable;
          choice.classList.toggle('disabled', !isAvailable);
          choice.setAttribute('aria-disabled', String(!isAvailable));
          choice.closest('.m-product-option--node')?.classList.toggle('m-product-option--node__unavailable', !isAvailable);
        });
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}
